<template lang="pug">
  tbody
    tr.item(:class="rowClass + ' ' +(open ? 'open' : 'close')")
      td(
        v-for="(item, i, a) in value"
        :key='i'
        @click="expand(value, i)"
      )
        span(v-if="a == 0 && value.has_children").arrow
        span {{ value[visibleColumns[a]] }}
      td
        editbuttons(
          :currentItem="value"
        )


</template>

<script>
  import editbuttons from './partials/garbageEditButtons.vue';
  import expandRow from './AtuExpandRow.vue';

  export default {
    data() {
      return {
        open: false,
        rowClass: ''
      };
    },
    name: 'expandRow',
    props: {
      value: '',
      visibleColumns: '',
      levelClass: '',
      method: '',
      depth: ''
    },
    components: {
      expandRow, editbuttons
    },
    methods: {
      expand(value, i) {
        this.open = !this.open;
        if (value.has_children && !value.childrens) {
          let apis;
          if (this.$route.meta.pageId === 'atuMain') {
            apis = atu.atuObjects;
          }
          let opts = {
            parent_id: value.id
          };
          apis.get(opts).then((response) => {
            if (response.data.data.length > 0) {
              console.log(response);

              console.log(value)
            // insert after i
            response.data.data.forEach((item, index) => {
              value.splice(i, 0, item);
              i++
            })

              // this.$set(value, 'childrens', response.data.data);
            }
          }, (response) => {
            console.log('error');
          });
        }
      },
      showModal() {

      },
      setClass() {
        let rowClass;
        switch (this.depth) {
          case 0:
            rowClass = 'first-level';
            break;
          case 1:
            rowClass = 'second-level';
            break;
          case 2:
            rowClass = 'third-level';
            break;
          case 3:
            rowClass = 'fourth-level';
            break;
          case 4:
            rowClass = 'fifth-level';
            break;
          default:
            break;
        }
        this.rowClass = rowClass;
      }
    },
    created() {
      this.setClass();
    }
  };
</script>

<style lang="scss">
.testCl{
	color: #77b9ff;
}
</style>
